import { useLang } from 'hooks/lang';

import { Alert, Button, Column } from 'components/Blocks';
import { CirclePlayIcon } from 'components/Icons';

import { useUser } from 'hooks/user';
import { recruitmentStatusConfig, actions } from 'entities';
import { useRecruitmentModal } from './context';

export function StartRecruitment() {
  const { t } = useLang();
  const user = useUser();

  const { recruitment, updateRecruitment } = useRecruitmentModal();

  const canStart = [
    recruitmentStatusConfig.notStarted.code === recruitment.status,
    user.id === recruitment.owner.id,
  ].every(Boolean);

  const startRecruitment = actions.projects.activateRecruitment.use({
    params: {
      recruitmentId: recruitment.id,
    },

    onSuccess: ({ recruitmentId }) =>
      updateRecruitment({
        ...recruitment,
        status: recruitmentStatusConfig.active.code,
        sampleRecruitmentId: recruitmentId,
      }),
  });

  if (!canStart) return null;

  return (
    <Column>
      <Alert title={t('sample-connection')} level="info">
        {t('starting-recruitment-sample')}
      </Alert>

      <Button
        {...startRecruitment.buttonProps}
        variant="outlined"
        color="success"
        className="mx-auto w-fit"
      >
        <CirclePlayIcon />
        {t('start-recruitment')}
      </Button>
    </Column>
  );
}
